<template>
  <v-snackbar
      color="#005096"
      v-model="snackbar"
      :multi-line="true"
      :timeout="timeout"
  >
    {{ text }}
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      snackbar: false,
      text: null,
      timeout: 2000,
    };
  },
  mounted() {
    this.$root.$on("show-info", this.showInfo);
  },
  destroyed() {
    this.$root.$off("show-info", this.showInfo);
  },
  methods: {
    showInfo(text) {
      this.snackbar = true;
      this.text = text
    },
  }
};
</script>

<style lang="scss">

</style>